var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { BeanBase, Use, Virtual } from 'zova';
import { Bean } from 'zova-module-a-bean';
export let BeanBehaviorBase = (_dec = Bean(), _dec2 = Virtual(), _dec3 = __z_BeanInfo({
  module: "a-behavior"
}), _dec4 = Reflect.metadata("design:type", Function), _dec5 = Reflect.metadata("design:paramtypes", [typeof OPTIONS === "undefined" ? Object : OPTIONS]), _dec6 = Use({
  injectionScope: 'host'
}), _dec7 = Reflect.metadata("design:type", typeof BeanBehavior === "undefined" ? Object : BeanBehavior), _dec8 = Use({
  injectionScope: 'host'
}), _dec9 = Reflect.metadata("design:type", typeof IBehaviorTag === "undefined" ? Object : IBehaviorTag), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = (_class2 = class BeanBehaviorBase extends BeanBase {
  constructor(options) {
    super();
    this.$options = void 0;
    _initializerDefineProperty(this, "$$beanBehavior", _descriptor, this);
    _initializerDefineProperty(this, "$$behaviorTag", _descriptor2, this);
    this.$options = options;
  }
  async onOptionsChange(options) {
    this.$options = options;
  }
  async createComposer(behaviors) {
    return await this.$$beanBehavior.createComposer(behaviors);
  }
  render(_props, next) {
    return next();
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "$$beanBehavior", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "$$behaviorTag", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class) || _class) || _class) || _class) || _class);